export const VERSION: '1.0.0' = '1.0.0';
